import {Col, Grid, Layout, Row} from "antd";
import {useEffect} from "react";
import AppConfig from "../../service/AppConfig";

// Mobil header sabit konumlu (position: fixed, 64px). İçerik onun altına girmesin diye üstte
// mutlaka bu kadar boşluk kalmalı — "kenara yapıştır" bunu kapsamaz.
const MOBILE_HEADER_HEIGHT = 64;

/**
 * @param flushOnMobile Dar ekranda yatay/alt boşlukları kaldırır; içerik ekranın kenarlarına yapışır.
 *                      Takvim gibi her pikseli kullanan ekranlar için. Üst boşluk korunur (bkz. üstte).
 */
export default function SimpleLayout({children, fullWidth=false, flushOnMobile=false})
{
    const screens = Grid.useBreakpoint();
    const flush = flushOnMobile && !screens.md;   // < 768px
    // Dar ekranda kenar boşluğu iki yanda eşit ve küçük (masaüstündeki 24/16 mobilde sol tarafı gereksiz açıyordu)
    const narrow = !screens.md;

    useEffect(() => {
        document.title =  AppConfig.getHisTitle()
    }, []);

    return (
        <Layout style={{
            marginTop: flush ? MOBILE_HEADER_HEIGHT : 80,
            marginLeft: flush ? 0 : narrow ? 8 : 24,
            marginBottom: flush ? 0 : 16,
            marginRight: flush ? 0 : narrow ? 8 : 16
        }}>
            <Row justify={'center'}>
                <Col xs={24} sm={24} md={24} lg={fullWidth ? 24 : 18} xl={fullWidth ? 24 : 14} xxl={fullWidth ? 24 : 12}>
                    {children}
                </Col>
            </Row>
        </Layout>
    )
}
